angular
    .module('MyApp')
    .service('EditaisService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.listarEditais = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/editais-projeto-vigentes',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.listarAnexos = function(idEdital){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/anexos-edital?id-edital=:idEdital',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idEdital
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

      this.inscreverProjeto = function(projeto){
        let deferr = $q.defer();
        if (projeto) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/edital/inscrever-se", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(projeto, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }


      this.listarValoresTipoPesquisa = function(){
        let deferr = $q.defer();
            $resource(Configs.getApiServer() + '/edital/valores-tipo-pesquisa',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        return deferr.promise;
      }

    }]);
